var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 16,
    viewBox: "0 0 2 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01053 11.3371C0.673684 11.3371 0.491228 11.1314 0.463158 10.72L0.105263 1.18857C0.091228 0.838096 0.161403 0.556191 0.315789 0.342856C0.470175 0.114285 0.694737 0 0.989474 0C1.29825 0 1.52982 0.114285 1.68421 0.342856C1.8386 0.556191 1.90877 0.838096 1.89474 1.18857L1.53684 10.72C1.50877 11.1314 1.33333 11.3371 1.01053 11.3371ZM0.905263 16C0.610526 16 0.385965 15.9086 0.231579 15.7257C0.077193 15.5276 0 15.2686 0 14.9486V14.4914C0 14.1714 0.077193 13.92 0.231579 13.7371C0.385965 13.5543 0.610526 13.4629 0.905263 13.4629H1.09474C1.38947 13.4629 1.61404 13.5543 1.76842 13.7371C1.92281 13.92 2 14.1714 2 14.4914V14.9486C2 15.2686 1.92281 15.5276 1.76842 15.7257C1.61404 15.9086 1.38947 16 1.09474 16H0.905263Z",
    fill: "#DBAE39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncompleteIcon);
export default __webpack_public_path__ + "static/media/IncompleteIcon.5f2710a265c631053616d6102d871ea8.svg";
export { ForwardRef as ReactComponent };